// extracted by mini-css-extract-plugin
module.exports = {"close":"close__bOqIS","icon":"icon__KBnUp"};